import axios from "axios";
import Swal from "sweetalert2";

const URL_POS = process.env.REACT_APP_URL_POS;

const cliente = () =>
  axios.create({
    baseURL: URL_POS,
    timeout: 30000,
    headers: { Authorization: `Bearer ${localStorage.getItem("app_token")}` },
  });

export const posGet = (ruta, params) => cliente().get(ruta, { params }).then((r) => r.data);
export const posPost = (ruta, data) => cliente().post(ruta, data).then((r) => r.data);
export const posPatch = (ruta, data) => cliente().patch(ruta, data).then((r) => r.data);

export const mensajeError = (e) =>
  (e && e.response && e.response.data && e.response.data.message) ||
  (e && e.message) ||
  "Ocurrió un error";

export const avisaError = (e) =>
  Swal.fire({ icon: "error", title: "No se pudo completar", text: mensajeError(e) });

export const avisaOk = (title, text) =>
  Swal.fire({ icon: "success", title, text, timer: 1800, showConfirmButton: false });

export const dinero = (n) =>
  "$" + Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const numero = (n) => Number(n || 0).toLocaleString("es-MX");

// Fecha de hoy en hora de CDMX (YYYY-MM-DD)
export const hoy = () =>
  new Date().toLocaleDateString("en-CA", { timeZone: "America/Mexico_City" });

export const sumaDias = (fecha, dias) => {
  const d = new Date(fecha + "T12:00:00Z");
  d.setUTCDate(d.getUTCDate() + dias);
  return d.toISOString().slice(0, 10);
};

export const fechaHora = (f) =>
  f
    ? new Date(f).toLocaleString("es-MX", {
        timeZone: "America/Mexico_City",
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      })
    : "";

export const hora = (f) =>
  f ? new Date(f).toLocaleTimeString("es-MX", { timeZone: "America/Mexico_City", hour: "2-digit", minute: "2-digit", hour12: false }) : "";

export const METODOS = { efectivo: "Efectivo", tdc: "Tarjeta", transfer: "Transferencia", cambio: "Saldo a favor" };

export const esMaster = (user) => !!user && user.rolTiendas === "master";
export const esTienda = (user) => !!user && user.rolTiendas === "tienda";

// Llave de una variante (modelo + color + talla)
export const llave = (a, c, t) => `${a || ""}|${c || ""}|${t || ""}`;
export const variante = (r) => [r.color, r.talla].filter(Boolean).join(" · ");
